/// <reference path="~/js/global.js"/>
/// <reference path="~/js/lib/backbone.js"/>
/// <reference path="~/js/lib/lodash.js"/>
/// <reference path="~/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="~/js/viz/profile/config/Config.js"/>

(function(Backbone, _) {
  "use strict";

  var ns;

  ns = window.nspace("ccc.viz.profile.views");

  /**
   * Monitors the state of the indicators in the model and updates the raw data link accordingly.
   */
  ns.PageTitleView = Backbone.View.extend({
    initialize: function(options) {
      _.bindAll(this);

      this.model.on("change", this.render);
    },

    render: function() {
      var locationId, location, pageTitle;

      locationId = this.model.get("locationId");
      location = _.filter(this.model.selectorInfo.locations, function(
        locationItem
      ) {
        return +locationItem.id === +locationId;
      })[0];

      if (!location || !location.name) {
        return;
      }

      pageTitle = location.name + " - Profiles of New York City's children";

      if (document.title === pageTitle) {
        return;
      }

      document.title = pageTitle;
    }
  });
})(Backbone, _);
